/**
 * @since 2023-07-31
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import BarActionsAnalysis from "components/Shared/BarActionsAnalysis";
import ButtonBlue from "components/Shared/ButtonBlue";
import Report from "components/Shared/Report";
import TextCopyright from "components/Shared/TextCopyright";
import TextError from "components/Shared/TextError";
import TextWait from "components/Shared/TextWait";
import {
  createImportedAnalysis,
  getStatusImportedAnalysis,
  loadImportedAnalysis,
  waitForImportedAnalysis,
} from "dataHandling/imported";
import { useEffect, useState } from "react";

const PanelAnalysis = ({ email, importedId, importedName, onScoresClick }) => {
  //region States

  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [analysisData, setAnalysisData] = useState({});

  //endregion

  //region Use Effects

  useEffect(() => {
    fetchData();
  }, [importedId, email]);

  //endregion

  //region Methods

  const fetchData = async () => {
    setIsLoading(true);
    let newStatus = await getStatusImportedAnalysis(email, importedId);
    if (newStatus === "WAITING") {
      setStatus(newStatus);
      newStatus = await waitForImportedAnalysis(email, importedId);
    }
    if (newStatus === "OK") {
      const newAnalysisData = await loadImportedAnalysis(email, importedId);
      setAnalysisData(newAnalysisData);
    }
    setStatus(newStatus);
    setIsLoading(false);
  };

  const handleCreateAnalysis = async () => {
    setStatus("WAITING");
    await createImportedAnalysis(email, importedId);
    fetchData();
  };

  //endregion

  return (
    <>
      {status === "WAITING" && <TextWait />}
      {status === "ERROR" && (
        <>
          <TextError error="Something went wrong, we are working on it. Please try again later." />
          <ButtonBlue
            label="CREATE ANALYSIS"
            alignment="left"
            onClick={handleCreateAnalysis}
          />
        </>
      )}
      {status === "NEW" && (
        <ButtonBlue
          label="CREATE ANALYSIS"
          alignment="left"
          onClick={handleCreateAnalysis}
        />
      )}
      {status === "OK" && (
        <>
          <Report
            email={email}
            moduleType={"IMPORTED"}
            moduleId={importedId}
            reportData={analysisData}
          />
          <br />
          <br />
          <BarActionsAnalysis
            email={email}
            moduleType={"IMPORTED"}
            moduleId={importedId}
            moduleName={importedName}
            showTrades={false}
          />
          <br />
          <ButtonBlue label="SEE SCORES" onClick={onScoresClick} />
          <TextCopyright />
        </>
      )}
    </>
  );
};
export default PanelAnalysis;
